import { ReactElement } from 'react'
import { Grid, Select, Text } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import CompanyCardPage from '../../companycard'
import { PropsStartAndEndTimeTemplate } from './props'

const StartAndEndTimeTemplate = ({
    currentStep,
    helpers,
    fromTimeOptions,
    toTimeOptions,
    onChangeStart,
    onChangeFinish,
    wantedFromTime,
    wantedToTime,
    dataCy,
}: PropsStartAndEndTimeTemplate): ReactElement => {
    const { t } = useTranslation()

    const toTime = wantedToTime && { label: wantedToTime, value: wantedToTime }
    const fromTime = wantedFromTime && {
        label: wantedFromTime,
        value: wantedFromTime,
    }

    const choosenText =
        wantedFromTime && wantedToTime && `${wantedFromTime} - ${wantedToTime}`

    return (
        <CompanyCardPage
            choosenText={choosenText ? [choosenText] : undefined}
            dataCy={dataCy}
            onClickNext={helpers.goToNextStep}
            open={currentStep === 4}
            setOpen={() => helpers.setStep(currentStep === 4 ? 7 : 4)}
            title={t('companylead.startend.header')}
        >
            <Text>{t('companylead.startend.text')}</Text>
            <Grid gap="16" autoFlow="column">
                <Grid gap="4">
                    <Text primary bold>
                        {t('companylead.startend.start')}
                    </Text>
                    <Select
                        data-cy="LeadStartTime"
                        label={t('companylead.startend.choose')}
                        onChange={(option) =>
                            onChangeStart(option ? option.value : undefined)
                        }
                        options={fromTimeOptions}
                        showUnselectOption
                        unselectText={t('companylead.startend.choosenone')}
                        value={fromTime ? fromTime : undefined}
                    />
                </Grid>
                <Grid gap="4">
                    <Text primary bold>
                        {t('companylead.startend.end')}
                    </Text>
                    <Select
                        data-cy="LeadEndTime"
                        label={t('companylead.startend.choose')}
                        onChange={(option) =>
                            onChangeFinish(option ? option.value : undefined)
                        }
                        options={toTimeOptions}
                        showUnselectOption
                        unselectText={t('companylead.startend.choosenone')}
                        value={toTime ? toTime : undefined}
                    />
                </Grid>
            </Grid>
        </CompanyCardPage>
    )
}

export default StartAndEndTimeTemplate
